import TableHeader from './TableHeader';

export default TableHeader;
